angular
  .module("admin.subscriptions")
  .controller(
    "FreeplayEdit",
    function ($uibModalInstance, FreePlayResource, fp) {
      this.model = {};

      if (fp) {
        if (fp.startDate) this.model.startDate = new Date(fp.startDate + 'T00:00:00');
        if (fp.endDate) this.model.endDate = new Date(fp.endDate + 'T00:00:00');
        this.model.id = fp.id;
        this.model.subscriptionNumber = fp.subscriptionNumber;
      } else {
        this.model.startDate = new Date();
      }

      this.dismiss = function () {
        $uibModalInstance.dismiss();
      };

      this.validateDates = function () {
        if (this.model.startDate && this.model.endDate) {
          return this.model.endDate >= this.model.startDate;
        }
        return true;
      };

      this.submit = function (frm) {
        frm.$setSubmitted(true);

        if (frm.$invalid) return;

        if (!this.validateDates()) {
          frm.endDate.$setValidity('dateRange', false);
          return;
        }
        frm.endDate.$setValidity('dateRange', true);

        var payload = {
          id: this.model.id,
          startDate: this.model.startDate.toISOString(),
          subscriptionNumber: this.model.subscriptionNumber,
          endDate: null,
        };

        if (this.model.endDate) {
          payload.endDate = this.model.endDate.toISOString();
        }

        if (payload.id) {
          FreePlayResource.update({ id: payload.id }, payload, () => {
            $uibModalInstance.close();
          });
          return;
        }

        FreePlayResource.create(payload, () => {
          $uibModalInstance.close();
        });
      };
    }
  );
